import type { RouteObject } from "react-router-dom";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { SelectStorePage } from "./pages/SelectStorePage";
import { StoreLookupRedirectPage } from "./pages/StoreLookupRedirectPage";

export const authRoutes: RouteObject[] = [
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    // Post-login store picker for multi-store sellers. Lives under `/:locale`
    // (NOT under `:storeSlug`) alongside login. Auth is enforced inside the
    // page: it fetches the session and redirects 401/403 → `/{locale}/login`.
    path: "select-store",
    element: <SelectStorePage />,
  },
  {
    path: "store-lookup",
    element: <StoreLookupRedirectPage />,
  },
];
